import type User from "@kamae-apps/shared/Types/User"
import { userService } from "../../Services/UserServices"

export async function fetchUserData(): Promise<User> {
  return userService.fetchUserData()
}

export async function fetchUserV1Data(): Promise<User> {
  return userService.fetchUserV1Data()
}

export async function updateUserData(body: User): Promise<User> {
  return userService.updateUserData(body)
}
